import { IsNumber, IsObject, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

/**
 * DTO for updating the grading/notation of an attempt
 */
export class UpdateGradingRequestDto {
  @ApiPropertyOptional({ description: 'Score obtained', example: 3 })
  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  score?: number;

  @ApiPropertyOptional({ description: 'Maximum score', example: 4 })
  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  maxScore?: number;

  @ApiProperty({
    description: 'Feedback message for the student',
    example: {
      message:
        'Bon travail ! Attention aux caractéristiques de la Mésopotamie et de la Grèce.',
    },
  })
  @IsOptional()
  @IsObject()
  feedback?: { message: string };
}
